<form #identifiersForm="ngForm">
  <hw-flex-editable-table
    #identifiersTable
    header="mdm.obs-def-02.identifiers.header"
    [form]="identifiersForm"
    [data]="definition.identifiers"
    [rowInstance]="defaultIdentifierRow"
    [editMode]="editMode">
    <hw-flex-editable-column title="mdm.obs-def-02.identifiers.system" name="system">
      <ng-template #viewTemplate let-identifier>
        {{ identifier.system }}
      </ng-template>
      <ng-template #editTemplate let-identifier>
        <hw-select name="system" [(ngModel)]="identifier.system" required>
          <hw-option label="SNOMED" value="SNOMED"></hw-option>
          <hw-option label="LOINC" value="LOINC"></hw-option>
          <hw-option label="OID" value="OID"></hw-option>
        </hw-select>
      </ng-template>
    </hw-flex-editable-column>

    <hw-flex-editable-column title="mdm.obs-def-02.identifiers.value" name="value">
      <ng-template #viewTemplate let-identifier>
        {{ identifier.value }}
      </ng-template>
      <ng-template #editTemplate let-identifier>
        <input nz-input name="value" [(ngModel)]="identifier.value" required />
      </ng-template>
    </hw-flex-editable-column>

    <hw-flex-editable-column title="mdm.obs-def-02.identifiers.description" name="description">
      <ng-template #viewTemplate let-identifier>
        {{ identifier.description }}
      </ng-template>
      <ng-template #editTemplate let-identifier>
        <input nz-input name="description" [(ngModel)]="identifier.description" />
      </ng-template>
    </hw-flex-editable-column>
  </hw-flex-editable-table>
</form>
